import React from 'react';
import {
  ClockCircleOutlined,
  FolderViewOutlined,
  GroupOutlined,
  SettingOutlined,
} from '@ant-design/icons';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import IBDIcon from '@totem/styles/Icon';
import { UserProfile } from '@totem/types/user';

export const getSubMenuTicketing = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'ticketing',
      title: 'Open Tickets',
      description: 'Service & Support Tickets',
      route: '/dashboard/ticketing',
      label: 'Open Tickets',
      icon: <IBDIcon name="Ticket" />,
      hasPermissions: () => {
        return permissions.ticketingViewer.hasPermissions(
          userProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'mytickets',
      title: 'My Tickets',
      description: "Tickets You're Involved With",
      route: '/dashboard/myTickets',
      label: 'My Tickets',
      icon: <IBDIcon name="Ticket" />,
      hasPermissions: () => {
        return true;
      },
    },
    {
      key: 'ticketDashboard',
      title: 'Dashboard',
      description: 'Internal Ticket Dashboard',
      route: '/dashboard/ticketDashboard',
      label: 'Ticket Dashboard',
      icon: <IBDIcon name="Ticket" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.ticketingInternal.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'projectsDashboard',
      title: 'Projects',
      description: 'Internal Projects Dashboard',
      route: '/dashboard/projectsDashboard',
      label: 'Projects Dashboard',
      icon: <IBDIcon name="Ticket" />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.ticketingInternal.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'opsTeamHuddle',
      title: 'Ops Team Dashboard',
      label: 'Ops Team Dashboard',
      description: 'Ops Team Dashboard',
      route: '/dashboard/opsTeamHuddle',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.internal.hasPermissions(userProfile);
      },
    },
    {
      key: 'ticket_aging',
      title: 'Aging',
      description: 'Ticket Aging',
      route: '/dashboard/ticketAging',
      label: 'Aging',
      icon: <ClockCircleOutlined />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.ticketingInternal.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'ticket_queues',
      title: 'Queues',
      description: 'Ticketing Queues',
      route: '/dashboard/ticketingQueues',
      label: 'Queues',
      icon: <FolderViewOutlined />,
      hasPermissions: (chkProfile: UserProfile) => {
        return permissions.ticketingInternal.hasPermissions(
          chkProfile,
          securityGroupCheckConstraintAny,
        );
      },
    },
    {
      key: 'queueManagement',
      title: 'Queue Administration',
      description: 'Create, Edit, and Assign Ticketing Queues',
      route: '/dashboard/ticketingQueueManagement',
      label: 'Queue Administration',
      icon: <SettingOutlined />,
      hasPermissions: (chkProfile: UserProfile) => {
        return (
          permissions.internalIBOrg.hasPermissions(chkProfile) &&
          permissions.ticketingAdministrator.hasPermissions(chkProfile)
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
